const ReportRoutes = [
    {
        path: 'salesTargetReport',
        name: 'salesTargetReport',
        component: () => import('@/views/Report/salesTargetReport'), // 销售市场KPI/STI目标
        meta: {
            title: 'saleTargetReport'
        }
    },
    {
        path: 'salesKPIScoreReport',
        name: 'salesKPIScoreReport',
        component: () => import('@/views/Report/salesKPIScoreReport'), // 销售市场KPI评分
        meta: {
            title: 'salesKPIScoreReport'
        }
    },
    {
        path: 'salesSTIScoreReport',
        name: 'salesSTIScoreReport',
        component: () => import('@/views/Report/salesSTIScoreReport'), // 销售市场STI评分
        meta: {
            title: 'salesSTIScoreReport'
        }
    },
    {
        path: 'salesResultsSummaryReport',
        name: 'salesResultsSummaryReport',
        component: () => import('@/views/Report/salesResultsSummaryReport'), // 销售市场KPI/STI结果汇总表
        meta: {
            title: 'salesResultsSummaryReport'
        }
    },
    {
        path: 'functionSalesSTISummaryReport',
        name: 'functionSalesSTISummaryReport',
        component: () => import('@/views/Report/functionSalesSTISummaryReport'), // 职能/销售市场STI汇总表
        meta: {
            title: 'functionSalesSTISummaryReport'
        }
    },
    {
        path: 'functionalAssessmentReport',
        name: 'functionalAssessmentReport',
        component: () => import('@/views/Report/functionalAssessmentReport'), // 职能考核绩效明细表
        meta: {
            title: 'functionalAssessmentReport'
        }
    },
    {
        path: 'developmentPlanReport',
        name: 'developmentPlanReport',
        component: () => import('@/views/Report/developmentPlanReport'), // 个人发展计划明细表
        meta: {
            title: 'developmentPlanReport'
        }
    },
    {
        path: 'summaryAssessmentReport',
        name: 'summaryAssessmentReport',
        component: () => import('@/views/Report/summaryAssessmentReport'), // 考核结果汇总
        meta: {
            title: 'summaryAssessmentReport'
        }
    },
    {
        path: 'companyTargetExportReport',
        name: 'companyTargetExportReport',
        component: () => import('@/views/Report/companyTargetExportReport'), // 公司目标导出报表
        meta: {
            title: 'companyTargetExportReport'
        }
    },
    {
        path: 'executivePerformanceSummary',
        name: 'executivePerformanceSummary',
        component: () => import('@/views/Report/executivePerformanceSummary'), // 高管绩效汇总表
        meta: {
            title: 'executivePerformanceSummary'
        }
    },
]
export default ReportRoutes